import React from 'react';
import type { ViewProps } from 'react-native';

import type { AuthRedirectTarget } from '../../navigation/AppNavigation.props';

// ────────────────────────────────────────────────────────────────────────────────

export const AuthFlowProvider = ({ children }: AuthFlowContextProps) => {
  const [authRedirectTarget, setAuthRedirectTarget] =
    React.useState<AuthRedirectTarget>();

  const value = React.useMemo(
    () => ({
      authRedirectTarget,
      setAuthRedirectTarget,
    }),
    [authRedirectTarget, setAuthRedirectTarget],
  );

  return (
    <AuthFlowContext.Provider value={value}>
      {children}
    </AuthFlowContext.Provider>
  );
};

const AuthFlowContext = React.createContext({
  authRedirectTarget: undefined,
  setAuthRedirectTarget: () => null,
} as AuthRedirectContextValue);

export const useAuthFlowContext = () => React.useContext(AuthFlowContext);

type AuthRedirectContextValue = {
  readonly authRedirectTarget: AuthRedirectTarget | undefined;
  readonly setAuthRedirectTarget: React.Dispatch<
    React.SetStateAction<AuthRedirectTarget | undefined>
  >;
};

type AuthFlowContextProps = Pick<ViewProps, 'children'>;
